import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enTranslation from './locales/en/translation.json'
import * as moment from 'moment/moment.js'
import 'moment/locale/en-gb'

const getCookie = (cname) => {
    var name = cname + '='
    var decodedCookie = decodeURIComponent(document.cookie)
    var ca = decodedCookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

export const getLang = () => {
    let wpmlCurrentLanguage = ''

    // Get lang in front
    if (document.getElementsByClassName('frontend').length > 0) {
        wpmlCurrentLanguage = document.documentElement.lang.split('-').shift() || 'fr'
    }
    // Get lang in back office
    else {
        wpmlCurrentLanguage = getCookie('wp-wpml_current_language') || 'fr'
    }

    return wpmlCurrentLanguage
}

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: { translation: enTranslation },
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    })

// Custom detector
let wpmlCurrentLanguage = getLang()
i18n.changeLanguage(wpmlCurrentLanguage)

// Setup locale for moment
moment.locale('fr-fr')
if (wpmlCurrentLanguage !== '' && wpmlCurrentLanguage !== 'fr') {
    moment.locale(wpmlCurrentLanguage)
}

export default i18n
